import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Building2, Mail, MapPin, Target, LogOut, RefreshCw, Pencil } from "lucide-react";
import { Layout } from "../components/Layout";
import { useApp } from "../context/AppContext";
import { Button } from "../components/ui/button";
import { ProfileEdit } from "../components/ProfileEdit";

export default function Profile() {
  const nav = useNavigate();
  const { user, data, demo, logout } = useApp();
  const [editOpen, setEditOpen] = useState(false);
  const o = data?.onboarding || {};

  const rows = [
    { icon: Building2, label: "Entreprise", value: o.business_name || "—" },
    { icon: MapPin, label: "Localisation", value: [o.city, o.country].filter(Boolean).join(", ") || "—" },
    { icon: Target, label: "Activité", value: o.activity_type || "—" },
    { icon: Target, label: "Objectif principal", value: o.main_goal || "—" },
    { icon: Mail, label: "Email", value: user?.email || (demo ? "demo (NOVA COFFEE)" : "—") },
  ];

  return (
    <Layout>
      <div className="mb-6"><h1 className="font-display font-black text-2xl lg:text-3xl">Profil entreprise</h1><p className="text-sm text-[hsl(var(--muted-foreground))]">Vos informations et paramètres.</p></div>
      <div className="max-w-lg space-y-4">
        <div className="lb-card p-6" data-testid="profile-card">
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-primary to-neon flex items-center justify-center font-display font-black text-2xl text-white">{(o.business_name || "L")[0]}</div>
            <div className="flex-1 min-w-0"><h2 className="font-display font-bold text-xl truncate">{o.business_name || "Mon entreprise"}</h2><p className="text-sm text-[hsl(var(--muted-foreground))]">{demo ? "Mode démonstration" : user?.name || "Membre"}</p></div>
            <Button data-testid="profile-edit-open" onClick={() => setEditOpen(true)} variant="outline" size="sm" className="rounded-full border-white/10 bg-white/5 h-9 shrink-0"><Pencil size={14} className="mr-1.5" /> Modifier</Button>
          </div>
          <div className="space-y-3">
            {rows.map((r, i) => (
              <div key={i} className="flex items-center gap-3 py-2 border-b border-white/5 last:border-0">
                <r.icon size={16} className="text-[hsl(var(--muted-foreground))]" />
                <span className="text-xs text-[hsl(var(--muted-foreground))] w-28">{r.label}</span>
                <span className="text-sm font-medium flex-1 text-right">{r.value}</span>
              </div>
            ))}
          </div>
        </div>

        <Button data-testid="profile-reanalyze" onClick={() => nav("/onboarding")} variant="outline" className="w-full rounded-full border-white/10 bg-white/5 h-11"><RefreshCw size={15} className="mr-2" /> Relancer l'analyse</Button>
        <Button data-testid="profile-logout" onClick={() => { logout(); nav("/"); }} variant="outline" className="w-full rounded-full border-red-500/20 text-red-400 bg-red-500/5 hover:bg-red-500/10 h-11"><LogOut size={15} className="mr-2" /> Déconnexion</Button>
      </div>
      <ProfileEdit open={editOpen} onOpenChange={setEditOpen} />
    </Layout>
  );
}
